import React, { memo } from 'react';

import WebpImage from '@r1-frontend/ui-react/components/WebpImage';

import * as ST from './styled';

// @todo Следует брать из api-domru/src/api-content/v1/tariff-lines
interface ILabel {
    id: number,
    title: string,
}

// @todo Следует брать из api-domru/src/api-content/v1/tariff-lines
export interface IContentsItem {
    id: number,
    title: string,
    image: string,
    image_webp: string,
    body: string,
    sort: number,
    labels?: ILabel[],
}

interface ITariffLineCard {
    onBtnClick?: () => void,
    item: IContentsItem,
}

const TariffLineCard = ({ onBtnClick, item }: ITariffLineCard) => {
    return (
        <ST.CardWrapper withCellSpacing={true} onClick={onBtnClick}>
            {item.labels?.map(label =>
                <ST.Header key={label.id}>{label.title}</ST.Header>)}
            <WebpImage urlWebp={item.image_webp}>
                <ST.ImageBlock src={item.image} />
            </WebpImage>
            <ST.Bottom>
                <ST.Text>
                    {item.title}
                </ST.Text>
                <ST.Button onClick={onBtnClick}/>
            </ST.Bottom>
        </ST.CardWrapper>
    );
};

export default memo(TariffLineCard);
